<template>
  <div class="antpro">
    <TopHP
      title="ANTDIY Pro:"
      wrap="The Change-Oriented ERP for online business, Proactive and Intelligent"
      content="A Sustainable Profit Generation Workflow"
      btn="Free trial for 30 days"
      img="/static/imgs/antsupply_top.svg"
      bg="top_bg_p_pro"
      tlcontent="top_left_content_pro"
      tlsymbol="top_left_symbol_pro"
      tlcontent1="top_left_content_1_pro"
      operationBtnEvent="true"
      @operationBtn="bookModal = true"
    ></TopHP>

    <div class="antpro_content">
      <div class="antpro_content_box">
        <h3 class="antpro_content_title">
          Powered by AI and automation technology, <br />
          ANTDIY Pro empower entrepreneurs by:
          <div class="title_icon"></div>
        </h3>
        <div class="antpro_introduce_part">
          <img
            class="antpro_introduce_part_img"
            src="/static/imgs/antdiypro_1.svg"
          />
          <div class="antpro_introduce_part_content">
            <h4 class="antpro_introduce_part_content_title">
              Scaling business on multichannel with smart integration
            </h4>
            <p class="antpro_introduce_part_content_msg">
              With ANTDIY Pro’s seamless integration, you get to sell with more
              than 30 channels and marketplaces around the world. Collect and
              edit product information, choose multiple channels, multiple
              online stores, and publish with one click.
            </p>
          </div>
        </div>
        <div class="antpro_content_img_smart_integration_wrapper">
          <img
            class="antpro_content_img_smart_integration antpro_content_img_pc"
            src="/static/imgs/smart_integration.svg"
          />
          <img
            class="antpro_content_img_smart_integration antpro_content_img_mo"
            src="/static/imgs/smart_integration_m.svg"
          />
          <p class="antpro_content_img_smart_integration_text2">
            Smart Integration
          </p>
          <p class="antpro_content_img_smart_integration_text1">User Input</p>
        </div>
        <div class="antpro_introduce_img_wrapper rotate180">
          <img
            class="antpro_introduce_img antpro_content_img_pc"
            src="/static/imgs/antdiypro_1to2.svg"
          />
          <img
            class="antpro_introduce_img antpro_content_img_mo"
            src="/static/imgs/antdiypro_1to2_m.svg"
          />
        </div>
        <div class="antpro_introduce_part flex_direction m_text_right">
          <img
            class="antpro_introduce_part_img"
            src="/static/imgs/antdiypro_2.svg"
          />
          <div class="antpro_introduce_part_content">
            <h4 class="antpro_introduce_part_content_title text_right">
              Putting up a profitable product portfolio with AI
            </h4>
            <p class="antpro_introduce_part_content_msg">
              We have the world's largest product database connected with
              Alibaba, Aliexpress and 1688. With ANTDIY’s artificial
              intelligence and big data, our talents have developed a blue ocean
              business opportunity detector. Tell ANTDIY Pro your senses and
              interests, you get to know your promising product portfolio.
            </p>
          </div>
        </div>
        <div class="product_portfolio">
          <img
            class="antpro_content_img_smart_integration antpro_content_img_pc"
            src="/static/imgs/product_portfolio.svg"
          />
          <img
            class="antpro_content_img_smart_integration antpro_content_img_mo"
            src="/static/imgs/product_portfolio_m.svg"
          />
          <div class="product_portfolio_text_wrapper">
            <p class="product_portfolio_text1">User Input</p>
            <p class="product_portfolio_text2">ANTDIY<br />AI Strategy Model</p>
            <p class="product_portfolio_text3">
              Global tens of billions of product sources to be fulfilled
            </p>
            <p class="product_portfolio_text4">Product Portfolio</p>
          </div>
        </div>
        <div class="antpro_introduce_img_wrapper">
          <img
            class="antpro_introduce_img antpro_content_img_pc"
            src="/static/imgs/antdiypro_1to2.svg"
          />
          <img
            class="antpro_introduce_img antpro_content_img_mo"
            src="/static/imgs/antdiypro_1to2_m.svg"
          />
        </div>
        <div class="antpro_introduce_part">
          <img
            class="antpro_introduce_part_img"
            src="/static/imgs/antdiypro_3.svg"
          />
          <div class="antpro_introduce_part_content">
            <h4 class="antpro_introduce_part_content_title">
              Maximizing supply chain flexibility with automated fulfillment
            </h4>
            <p class="antpro_introduce_part_content_msg">
              ANTDIY Pro makes it possible to access millions of reliable
              suppliers from multi-platforms, and we can help you to get the
              most comprehensive supply chain cost optimization solution. With
              ANTDIY Pro, you can just push the buttons and your orders from
              more than 70 countries will be fulfilled with a fully automated
              process.
            </p>
          </div>
        </div>
        <img
          class="antpro_content_img_process antpro_content_img_pc"
          src="/static/imgs/antdiy_pro_one_click_fulfillment.svg"
          alt="Just press the buttons，ANTDIY Pro takes care of the rest. So Easy"
        />
        <img
          class="antpro_content_img_process antpro_content_img_mo"
          src="/static/imgs/antdiy_pro_one_click_fulfillment-m.svg"
          alt="Just press the buttons，ANTDIY Pro takes care of the rest. So Easy"
        />
        <div class="antpro_content_process">
          <p class="antpro_content_text_process">
            Just press the buttons，ANTDIY Pro takes care of the rest. So Easy！
          </p>
          <img
            class="antpro_content_img_mapping antpro_content_img_pc"
            src="/static/imgs/antdiy_pro_automatic_fulfillment.svg"
            alt="Aggregate multi-platform orders, intelligently combine orders, divide orders, source supplier mapping and worry-free logistics mapping, automatic fulfillment."
          />
          <img
            class="antpro_content_img_mapping antpro_content_img_mo"
            src="/static/imgs/antdiy_pro_automatic_fulfillment-m.svg"
            alt="Aggregate multi-platform orders, intelligently combine orders, divide orders, source supplier mapping and worry-free logistics mapping, automatic fulfillment."
          />
          <div class="antpro_content_text_footer_process">
            <p>Supplier & Logistics Mapping</p>
            <p>ANTDIY Pro Automatic Fulfillment</p>
          </div>
          <p class="antpro_content_text_footer_process_m1">
            Supplier & Logistics Mapping
          </p>
          <p class="antpro_content_text_footer_process_m2">
            ANTDIY Pro Automatic Fulfillment
          </p>
        </div>
        <img
          class="antpro_content_img_data antpro_content_img_pc"
          src="/static/imgs/antdiy_pro_full_visual_monitoring.svg"
          alt="Full visual monitoring."
        />
        <img
          class="antpro_content_img_data antpro_content_img_mo"
          src="/static/imgs/antdiy_pro_full_visual_monitoring-m.svg"
          alt="Full visual monitoring."
        />
        <p class="antpro_content_text_data">Full visual monitoring</p>
        <p class="antpro_content_text">
          Visual Monitoring on imputation from multi-sources, to-procure order
          restructure, suppliers and logistics service providers mapping and
          fulfillment process tracking.
        </p>
        <div class="antpro_answer">
          <div
            class="antpro_answer_part"
            v-for="item in answerList"
            :key="item.main_question"
          >
            <div class="antpro_answer_part_img_wrapper">
              <img class="antpro_answer_part_img_main" :src="item.main_img" />
              <img :src="item.serial_img" />
            </div>
            <h4 class="antpro_answer_part_main_question">
              {{ item.main_question }}
            </h4>
            <ul>
              <li
                class="antpro_answer_part_list"
                v-for="ele in item.list"
                :key="ele"
              >
                <span class="antpro_answer_part_list_circle"></span>
                <span>{{ ele }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="antpro_content_bg antpro_content_bg1"></div>
    </div>
    <div class="ant_faqs">
      <div class="ant_faqs_box">
        <h3 class="ant_faqs_title">
          Talents are always there for you!
          <div class="title_icon"></div>
        </h3>
        <p class="ant_faqs_msg">
          Experts experienced in Business Strategy/Ecommerce Operation/
          Fulfillments/Martech stand by to provide professional assistances any
          time you need.
        </p>
        <div class="ant_faqs_text_wrapper">
          <img
            class="ant_faqs_img antpro_content_img_pc"
            src="/static/imgs/antpro_talents.svg"
          />
          <img
            class="ant_faqs_img antpro_content_img_mo"
            src="/static/imgs/antpro_talents_m.svg"
          />
          <p class="ant_faqs_text1">Full scan of your store</p>
          <p class="ant_faqs_text2">Analyze your products and suppliers</p>
          <p class="ant_faqs_text3">Generate store’s diagnostic report</p>
          <p class="ant_faqs_text4">
            Recommend blue ocean platforms, niche markets<br />products and
            suppliers
          </p>
        </div>
      </div>
    </div>
    <div class="antpro_footer">
      <div class="antpro_footer_content">
        <h3 class="antpro_footer_content_title">
          We know you and this business!
          <div class="title_icon"></div>
        </h3>
        <p class="antpro_footer_content_msg">
          Livechat us to join Seed User Program<br />
          You will be matched with 1-to-1 expert to optimize your business
          workflow
        </p>
        <div class="ad_button" @click="bookModal = true">Book a demo</div>
      </div>
    </div>
    <Footer start="Start your sustainable online business now"></Footer>
    <AppointmentDemo :isShow="bookModal" @close="bookModal = false" />
  </div>
</template>

<script>
import Header from "./common/header.vue";
import Footer from "./common/footer.vue";
import TopHP from "./common/topHP.vue";
import AppointmentDemo from "./common/appointmentDemo.vue";

export default {
  name: "AntDiyPro",
  components: {
    Header,
    Footer,
    TopHP,
    AppointmentDemo,
  },
  data() {
    return {
      answerList: [
        {
          main_img: "/static/imgs/antdiypro_4.1.svg",
          serial_img: "/static/imgs/antdiypro_4.2.svg",
          main_question: "Where you sell?",
          sub_question: "eggs in one basket?",
          list: [
            "Scale your business with integration to 30+channels and marketplaces around the world",
            "Transform and optimize your product content to comply with the requirements of each marketplace",
            "Support multi-platform, multi-store, multi-product, batch product listing",
            "Find blue ocean e-commerce platforms for your products, increase sales",
            "Replicate products between multiple stores",
          ],
        },
        {
          main_img: "/static/imgs/antdiypro_5.1.svg",
          serial_img: "/static/imgs/antdiypro_5.2.svg",
          main_question: "What you sell?",
          sub_question: "profit comes from sales or your choice?",
          list: [
            "The world's largest product database with more than 30,000,000 products",
            "Select winning products through AI and big data, provide customized product portfolio",
            "Import products flexibly with 1 click: URL, Google plugin, and marketplace import methods are supported",
            "1-click pricing strategy setting & Product information editing & Online photo editing",
            "Automated cost and profit measurement",
          ],
        },
        {
          main_img: "/static/imgs/antdiypro_6.1.svg",
          serial_img: "/static/imgs/antdiypro_6.2.svg",
          main_question: "How you run it?",
          sub_question: "cost under control?",
          list: [
            "Scale and manage your business with ease across multiple stores and platforms",
            "Easily create, map, and sync product content to your webstore using a single product data feed",
            "Synchronize orders from multiple selling channels and map them to the purchasing platform, place order with 1-click",
            "Full logistics tracking",
          ],
        },
      ],
      bookModal: false,
    };
  },
};
</script>

<style scoped>
.antpro_content_bg {
  position: absolute;
  width: 110%;
  height: 583px;
  border-radius: 292px;
  opacity: 0.5;
  border: 120px solid #ffffff;
}
.antpro_content {
  background: #f6f7fa;
  position: relative;
  overflow: hidden;
}
.antpro_content_box {
  width: 1200px;
  padding: 81px 0 80px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.antpro_content_title {
  font-family: Helvetica-Bold;
  font-size: 32px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 40px;
  font-weight: 700;
}
.antpro_content_title > div {
  width: 60px;
  height: 8px;
  border-radius: 6px;
  margin: 23px auto 0;
}
.antpro_content_subtitle {
  margin-top: 31px;
  font-family: Helvetica;
  font-size: 20px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
}
.antpro_content_main {
  text-align: center;
}
.antpro_content_process {
  position: relative;
}
.antpro_content_text_process {
  position: absolute;
  text-align: center;
  top: 60px;
  width: 100%;
  font-family: Helvetica;
  font-size: 22px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
  margin: 0;
}
.antpro_content_text_footer_process {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-family: Helvetica;
  font-size: 18px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
  position: absolute;
  bottom: 40px;
}
.antpro_content_text_footer_process_m1 {
  display: none;
}
.antpro_content_text_footer_process_m2 {
  display: none;
}
.antpro_content_text_footer_process p {
  width: 48%;
  text-align: center;
}
.antpro_content_img_pc {
  display: block;
}
.antpro_content_img_mo {
  display: none;
}
.antpro_content_img_smart_integration_wrapper {
  position: relative;
}
.antpro_content_img_smart_integration {
  width: 100%;
  margin: 80px auto 40px;
}
.antpro_content_img_smart_integration_text1 {
  position: absolute;
  font-family: Helvetica;
  font-size: 18px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
  left: 53px;
  top: 420px;
  width: auto;
}
.antpro_content_img_smart_integration_text2 {
  position: absolute;
  font-family: Helvetica;
  font-size: 18px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
  left: 440px;
  top: 616px;
  width: auto;
}
.antpro_content_text_smart_integration {
  font-family: Helvetica;
  font-size: 18px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
  margin-top: 18px;
}
.antpro_content_img_process {
  height: 100%;
  margin: 66px auto 0;
}
.antpro_content_img_mapping {
  height: 100%;
}
.antpro_content_img_data {
  height: 100%;
}
.antpro_content_text_data {
  display: block;
  font-family: Helvetica;
  font-size: 18px;
  margin-top: 35px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
}
.antpro_content_text {
  font-family: Helvetica;
  font-size: 22px;
  margin-top: 55px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
}
.antpro_content_bg1 {
  top: 390px;
  right: -67%;
}
.antpro_content_bg2 {
  top: 816px;
  left: -1575px;
}
.antpro_content_bg3 {
  top: 1337px;
  left: 1128px;
}
.ant_faqs {
  position: relative;
  background: #ffffff;
  padding: 81px 0 80px;
}
.ant_faqs_box {
  width: 1200px;
  margin: 0 auto;
}
.ant_faqs_title {
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  text-align: center;
}
.ant_faqs_title > div {
  width: 60px;
  height: 8px;
  border-radius: 6px;
  margin: 23px auto 0;
}
.ant_faqs_msg {
  font-family: Helvetica;
  font-size: 22px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
  margin-top: 55px;
}
.ant_faqs_img {
  margin-top: 63px;
  width: 100%;
}
.ant_faqs_text_wrapper {
  position: relative;
}
.ant_faqs_text_wrapper > p {
  font-family: Helvetica;
  font-size: 18px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
  position: absolute;
  width:auto;
  opacity: 1;
}
.ant_faqs_text1 {
  left: 183px;
  top: 304px;
}
.ant_faqs_text2 {
  left: 788px;
  top: 304px;
}
.ant_faqs_text3 {
  left: 788px;
  top: 766px;
}
.ant_faqs_text4 {
  left: 64px;
  top: 760px;
}
.antpro_introduce {
  width: 1020px;
  margin: 77px auto 0;
}
.product_portfolio {
  position: relative;
  padding-bottom: 0;
}
.product_portfolio > .antpro_content_img_smart_integration {
  margin: 58px auto 0;
}
.product_portfolio_text_wrapper > p {
  position: absolute;
  text-align: center;
  font-family: Helvetica;
  font-size: 18px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 22px;
  font-weight: 400;
}
.product_portfolio_text1 {
  left: 88px;
  top: 318px;
}
.product_portfolio_text2 {
  width: auto;
  left: 530px;
  top: 310px;
}
.product_portfolio_text3 {
  left: 923px;
  top: 310px;
}
.product_portfolio_text4 {
  left: 535px;
  top: 635px;
  width: auto;
}

.antpro_introduce_img_wrapper {
  width: 986px;
  height: 288px;
  margin: 0 auto;
  padding: 60px 0;
}
.antpro_introduce_img {
  width: 100%;
  height: 100%;
}

.rotate180 {
  transform: rotateY(180deg);
}
.text_right {
  text-align: right !important;
}
.flex_direction {
  flex-direction: row-reverse;
}
.antpro_content_box > .antpro_introduce_part {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.antpro_content_box > .antpro_introduce_part > .antpro_introduce_part_img {
  margin-right: 91px;
}
.antpro_content_box
  > .antpro_introduce_part
  > .antpro_introduce_part_img:last-of-type {
  margin-right: 81px;
}
.antpro_content_box > .flex_direction > .antpro_introduce_part_img {
  margin-left: 91px;
  margin-right: 0;
}
.antpro_content_box > .antpro_introduce_part > .antpro_introduce_part_content {
  width: 800px;
}
.antpro_content_box
  > .antpro_introduce_part
  > .antpro_introduce_part_content
  > .antpro_introduce_part_content_title {
  font-family: Helvetica-Bold;
  display: block;
  font-size: 24px;
  color: #222536;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 700;
}
.antpro_content_box
  > .antpro_introduce_part
  > .antpro_introduce_part_content
  > .antpro_introduce_part_content_msg {
  display: block;
  font-family: Helvetica;
  margin-top: 19px;
  font-size: 20px;
  color: #585e6e;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: 400;
}
.antpro_answer {
  padding: 10px 0 0;
  width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.antpro_answer_part {
  width: 470px;
  padding-top: 70px;
}
.antpro_answer_part_img_wrapper {
  display: flex;
  width: 195px;
  height: 149px;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 32px;
}
.antpro_answer_part_main_question {
  display: block;
  font-family: Helvetica;
  font-size: 24px;
  color: #222536;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 700;
  margin-bottom: 20px;
}
.antpro_answer_part_sub_question {
  display: block;
  font-family: Helvetica;
  font-size: 22px;
  color: #222536;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: 400;
  margin-bottom: 25px;
}
.antpro_answer_part_list {
  font-family: Helvetica;
  font-size: 20px;
  color: #585e6e;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: 400;
  margin-bottom: 16px;
  display: flex;
  align-items: baseline;
}
.antpro_answer_part_list_circle {
  display: block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  background: #222536;
  flex-shrink: 0;
  margin-right: 15px;
}
.antpro_footer {
  background-image: url("/static/imgs/antpro_footer.png");
  width: 100%;
}
.antpro_footer_content {
  width: 950px;
  padding: 80px 0;
  margin: 0 auto;
  text-align: center;
}
.antpro_footer_content_title {
  font-family: Helvetica-Bold;
  font-size: 32px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 40px;
  font-weight: 700;
}
.antpro_footer_content_title > div {
  width: 60px;
  height: 8px;
  border-radius: 6px;
  margin: 23px auto 0;
}
.antpro_footer_content_msg {
  margin: 44px 0 57px;
  font-family: Helvetica;
  font-size: 20px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
}

@media (max-width: 767px) {
  .antpro_content_bg {
    display: none;
  }
  .antpro_content {
    background: #f6f7fa;
    position: relative;
    overflow: hidden;
    width: 100%;
    padding: 0 0.48rem 0;
  }
  .antpro_content_box {
    width: 100%;
    padding: 0.7rem 0 0;
    margin: 0 auto;
    /* position: relative; */
    z-index: 1;
  }
  .antpro_content_title {
    font-family: Helvetica-Bold;
    font-size: 0.44rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.56rem;
    font-weight: 700;
  }
  .antpro_content_title > div {
    width: 0.6rem;
    height: 0.08rem;
    border-radius: 6px;
    margin: 0.3rem auto 0;
  }
  .antpro_content_subtitle {
    margin-top: 0.3rem;
    font-family: Helvetica;
    font-size: 0.24rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.36rem;
    font-weight: 400;
  }
  .title_icon {
    margin: 0.8rem 0 0.31rem;
  }
  .antpro_content_line_text_title {
    height: auto;
    font-size: 0.3rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.42rem;
    margin-bottom: 0.15rem;
  }
  .antpro_content_line_text_subtitle {
    height: auto;
    font-size: 0.28rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #fc5322;
    line-height: 0.34rem;
    margin-bottom: 0.2rem;
  }
  .antpro_content_line_text_content {
    width: 100%;
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #222536;
    line-height: 0.32rem;
  }
  .antpro_content_line_text_list {
    width: 100%;
    height: auto;
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #222536;
    line-height: 0.29rem;
    display: flex;
    align-items: flex-start;
  }
  .antpro_content_line_text_list em {
    display: inline-block;
    width: 0.1rem;
    height: 0.04rem;
    background: #fc5421;
    border-radius: 0.02rem;
    margin-right: 0.08rem;
    margin-top: 0.1rem;
    flex: 0 0 auto;
  }
  .antpro_content_line_text_list + .antpro_content_line_text_list {
    margin-top: 0.15rem;
  }
  .antpro_content_line_img {
    width: 100%;
    height: auto;
    margin-top: 0.5rem;
  }
  .antpro_content_line2 {
    flex-direction: column-reverse;
  }
  .antpro_content_box {
    width: 100%;
    padding: 0.7rem 0 0.8rem;
    margin: 0 auto;
    position: relative;
    z-index: 1;
  }
  .antpro_content_title {
    font-family: Helvetica-Bold;
    font-size: 0.44rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.56rem;
    font-weight: 700;
  }
  .antpro_content_title > div {
    width: 0.6rem;
    height: 0.08rem;
    border-radius: 6px;
    margin: 0.3rem auto 0;
  }
  .antpro_content_subtitle {
    margin-top: 0.3rem;
    font-family: Helvetica;
    font-size: 0.24rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.36rem;
    font-weight: 400;
  }
  .antpro_content_main {
    text-align: center;
  }
  .antpro_content_process {
    position: relative;
  }
  .antpro_content_text_process {
    position: static;
    text-align: center;
    width: 100%;
    font-family: Helvetica;
    font-size: 0.28rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.36rem;
    font-weight: 400;
    margin: 0.4rem 0 0.7rem;
  }
  .antpro_content_text_footer_process {
    display: none;
  }
  .antpro_content_text_footer_process_m1 {
    position: absolute;
    display: block;
    width: 100%;
    top: 50%;
    margin-top: -0.3rem;
    font-size: 0.2rem;
    color: #222536;
    text-align: center;
  }
  .antpro_content_text_footer_process_m2 {
    position: absolute;
    display: block;
    width: 100%;
    font-size: 0.2rem;
    color: #222536;
    bottom: 0.6rem;
    text-align: center;
  }
  .antpro_content_img_pc {
    display: none;
  }
  .antpro_content_img_mo {
    display: block;
  }
  .antpro_content_img_process {
    width: 100%;
    height: 100%;
    margin-top: 0.73rem;
  }
  .antpro_content_img_mapping {
    width: 100%;
    height: 100%;
  }
  .antpro_content_img_data {
    width: 100%;
    height: 100%;
  }
  .antpro_content_text_data {
    display: block;
    font-family: Helvetica;
    font-size: 0.2rem;
    margin-top: 0.2rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.28rem;
    font-weight: 400;
  }
  .antpro_content_text {
    font-family: Helvetica;
    font-size: 0.28rem;
    margin-top: 0.4rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.36rem;
    font-weight: 400;
  }
  .ant_faqs {
    position: relative;
    background: #ffffff;
    padding: 0.8rem 0;
  }
  .ant_faqs_box {
    width: 100%;
    margin: 0 auto;
    padding: 0 0.48rem;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .ant_faqs_title {
    font-size: 0.44rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.56rem;
    text-align: center;
  }
  .ant_faqs_title > .title_icon {
    width: 0.6rem;
    height: 0.08rem;
    margin: 0.3rem auto 0;
  }
  .ant_faqs_msg {
    font-family: Helvetica;
    font-size: 0.24rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.36rem;
    font-weight: 400;
  }
  .ant_faqs_text_wrapper {
    position: relative;
  }
  .ant_faqs_text_wrapper > p {
    font-family: Helvetica;
    font-size: .22rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: .28rem;
    font-weight: 400;
    position: absolute;
    width: 0;
    opacity: 0;
  }
  .ant_faqs_text1 {
    left: 0rem;
    top: 4.3rem;
    text-align: center;
  }
  .ant_faqs_text2 {
    left: 0rem;
    top: 9.5rem;
    text-align: center;

  }
  .ant_faqs_text3 {
    left: 0rem;
    top: 14.7rem;
    text-align: center;

  }
  .ant_faqs_text4 {
    left: 0rem;
    top: 19.75rem;
    text-align: center;
  }
  .antpro_introduce {
    width: 100%;
    margin: 0.7rem auto 0;
  }
  .antpro_introduce_img_wrapper {
    width: 5.78rem;
    height: 1.68rem;
    margin: 0.5rem auto;
    padding: 0;
  }
  .antpro_introduce_img {
    width: 100%;
    height: 100%;
  }
  .m_text_right {
    text-align: right;
  }

  .antpro_content_box > .antpro_introduce_part {
    display: block;
  }
  .antpro_content_box > .antpro_introduce_part > .antpro_introduce_part_img {
    width: 1.2rem;
    height: 1.2rem;
    margin: 0 0 0.4rem !important;
  }
  .antpro_content_box
    > .antpro_introduce_part
    > .antpro_introduce_part_content {
    width: 100%;
  }
  .antpro_content_box
    > .antpro_introduce_part
    > .antpro_introduce_part_content
    > .antpro_introduce_part_content_title {
    font-family: Helvetica-Bold;
    display: block;
    font-size: 0.3rem;
    line-height: 0.4rem;
    color: #222536;
    letter-spacing: 0;
    font-weight: 700;
  }
  .antpro_content_box
    > .antpro_introduce_part
    > .antpro_introduce_part_content
    > .antpro_introduce_part_content_msg {
    display: block;
    font-family: Helvetica;
    margin-top: 0.25rem;
    font-size: 0.24rem;
    color: #585e6e;
    letter-spacing: 0;
    line-height: 0.36rem;
    font-weight: 400;
  }
  .antpro_content_img_smart_integration_wrapper {
    position: relative;
  }
  .antpro_content_img_smart_integration {
    width: 100%;
    margin: 0.5rem auto 0;
  }
  .antpro_content_img_smart_integration_text1 {
    position: absolute;
    font-family: Helvetica;
    font-size: 0.24rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.28rem;
    font-weight: 400;
    left: 0;
    top: 3.15rem;
    width: 100%;
    text-align: center;
  }
  .antpro_content_img_smart_integration_text2 {
    position: absolute;
    font-family: Helvetica;
    font-size: 0.24rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.28rem;
    font-weight: 400;
    left: 0rem;
    top: 14.5rem;
    width: 100%;
    text-align: center;
  }
  .product_portfolio {
    position: relative;
    padding-bottom: 0.5rem;
  }
  .product_portfolio > .antpro_content_img_smart_integration {
    margin: 0.3rem auto 0;
  }
  .product_portfolio_text_wrapper > p {
    position: absolute;
    text-align: center;
    font-family: Helvetica;
    font-size: 0.24rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.28rem;
    font-weight: 400;
  }
  .product_portfolio_text1 {
    left: 0.83rem;
    top: 3.05rem;
  }
  .product_portfolio_text2 {
    left: 0rem;
    top: 7.7rem;
    text-align: center;
    width: 100%;
  }
  .product_portfolio_text3 {
    left: 3.75rem;
    top: 3.05rem;
  }
  .product_portfolio_text4 {
    white-space: nowrap;
    left: 0rem;
    top: 11.8rem;
    width: 100%;
    text-align: center;
  }

  .antpro_answer {
    padding: 0.35rem 0 0rem;
    width: 100%;
    display: block;
  }
  .antpro_answer_part {
    width: 100%;
    padding-top: 0.35rem;
  }
  .antpro_answer_part_img_wrapper {
    display: flex;
    width: 1.75rem;
    height: 1.14rem;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 0.35rem;
  }
  .antpro_answer_part_img_main {
    height: 100%;
  }
  .antpro_answer_part_img_main + img {
    height: 0.4rem;
  }

  .antpro_answer_part_main_question {
    display: block;
    font-family: Helvetica;
    font-size: 0.3rem;
    color: #222536;
    letter-spacing: 0;
    line-height: 0.28rem;
    font-weight: 700;
    margin-bottom: 0.25rem;
  }
  .antpro_answer_part_sub_question {
    display: block;
    font-family: Helvetica;
    font-size: 0.28rem;
    color: #222536;
    letter-spacing: 0;
    line-height: 0.26rem;
    font-weight: 400;
    margin-bottom: 0.3rem;
  }
  .antpro_answer_part_list {
    font-family: Helvetica;
    font-size: 0.24rem;
    color: #585e6e;
    letter-spacing: 0;
    line-height: 0.26rem;
    font-weight: 400;
    margin-bottom: 0.21rem;
    display: flex;
    align-items: baseline;
  }
  .antpro_answer_part_list_circle {
    display: block;
    border-radius: 50%;
    width: 0.12rem;
    height: 0.12rem;
    background: #222536;
    flex-shrink: 0;
    margin-right: 0.15rem;
  }
  .antpro_footer {
    background-image: url("/static/imgs/antpro_footer.png");
    padding: 0.7rem 0.48rem 1rem;
    height: auto;
    width: 100%;
  }
  .antpro_footer_content {
    width: 100%;
    padding: 0;
    margin: 0 auto;
    text-align: center;
  }
  .antpro_footer_content_title {
    font-family: Helvetica-Bold;
    font-size: 0.44rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.56rem;
    font-weight: 700;
  }
  .antpro_footer_content_title > div {
    width: 0.6rem;
    height: 0.08rem;
    border-radius: 6px;
    margin: 0.3rem auto 0;
  }
  .antpro_footer_content_msg {
    margin: 0.3rem 0 0.6rem;
    font-family: Helvetica;
    font-size: 0.24rem;
    color: #222536;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.36rem;
    font-weight: 400;
  }
  .ad_button {
    width: 100%;
    text-align: center;
    border-radius: 6px;
  }
}
</style>
<style>
.top_bg_p_pro {
  width: 1243px;
  height: 583px;
  border-radius: 292px;
  opacity: 0.85;
  border: 120px solid #f6f7fa;
  position: absolute;
  top: 59px;
  left: -636px;
}
.top_left_symbol_pro {
  margin: 90px 0 21px !important;
}
.top_left_content_pro {
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 21px;
  margin-bottom: 12px;
  color: #32404d;
  display: flex;
  align-items: flex-start;
}
.top_left_content_pro > em {
  margin-top: 4px;
}
.top_left_content_1_pro {
  font-family: Helvetica;
  font-size: 20px !important;
  color: #222536 !important;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 400;
  margin-bottom: 51px !important;
}
@media (max-width: 767px) {
  .top_bg_p_pro {
    display: none;
  }
  .top_left_symbol_pro {
    margin: .81rem 0 .36rem !important;
  }
  .top_left_content_pro {
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #8d919b;
    line-height: 0.3rem;
    margin: 0.3rem 0 0;
    color: #222536;
    display: flex;
    align-items: flex-start;
  }
  .top_left_content_1_pro {
    font-family: Helvetica;
    font-size: 0.28rem !important;
    color: #222536 !important;
    letter-spacing: 0;
    line-height: 0.42rem;
    font-weight: 400;
    margin-bottom: 0.59rem !important;
  }
  .top_left_content_pro > em {
    margin: 0.08rem 0.17rem 0 0 !important;
  }
  .top_left_content_pro:nth-child(4) {
    margin-bottom: 0.4rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/antDiyPro.vue